import React from 'react';
import { Page } from '../Common/Components/Page';
import { SupplyProfileManagementContent } from './Components/SupplyProfileManagementContent';

export const SupplyProfileManagement = (): React.JSX.Element => (
  <Page title="Supply Profiles" accessKey={'ekanbanProfiles'} isSearchable={true}>
    <SupplyProfileManagementContent />
  </Page>
);
